import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { Icon, Avatar } from '@components/atoms'
import {
	Alert24Regular,
	CaretDown20Filled,
	Person24Regular,
	/* 	Settings24Regular, */
	Globe24Regular,
	ChatMultiple24Regular,
	ArrowExit20Regular,
} from '@fluentui/react-icons'
import { useIsMobile } from '@hooks'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { dashboardAPI } from '@services/DashboardAPI'
import { headerCreators } from '@store/ducks/header'
import { premiumCreators } from '@store/ducks/premium'
import { profileCreators } from '@store/ducks/profile'
import { useAppDispatch } from '@store/hooks'

import { headerStyles } from './styles'

const {
	header: headerStyle,
	container,
	sidebar,
	person,
	personInfo,
	DropdownMenuContent,
	DropdownMenuRoot,
	DropdownMenuItem,
	DropdownMenuPortal,
	NavigationIcon,
	LinkIndex,
} = headerStyles

export default function HeaderBase() {
	const history = useNavigate()
	const dispatch = useAppDispatch()

	const handleOpenSideBar = () => {
		dispatch(headerCreators.openSidebar())
	}

	const [GetMe, { isSuccess, data }] = dashboardAPI.useGetMeMutation()
	const [GetProfile, { isSuccess: isSuccessGetProfile, data: dataGetProfile }] =
		dashboardAPI.useListMeProfileMutation()

	const mobile = useIsMobile()

	useEffect(() => {
		if (isSuccess && data) {
			dispatch(premiumCreators.setIsPremium({ value: data?.isPremium }))
		}

		if (isSuccessGetProfile && dataGetProfile) {
			dispatch(profileCreators.setIsProfile(dataGetProfile))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isSuccess, isSuccessGetProfile])

	useEffect(() => {
		GetMe()
		GetProfile()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<header className={headerStyle()}>
			<div className={container()}>
				<div className={sidebar()}>
					<NavigationIcon onClick={handleOpenSideBar} />

					<LinkIndex to='/'>
						<Icon title='logo DLS' name='logo' width={116} height={50} />
					</LinkIndex>
				</div>
				<div className={person()}>
					<DropdownMenuRoot modal={false}>
						<DropdownMenu.Trigger>
							<div className={personInfo()}>
								<Avatar
									src={(isSuccess && data?.imageUrl) || ''}
									alt='avatar'
									name={(isSuccess && data?.name) || ''}
									showName={!mobile}
								/>
								{!mobile && <CaretDown20Filled />}
							</div>
						</DropdownMenu.Trigger>

						<DropdownMenuPortal>
							<DropdownMenuContent sideOffset={10}>
								<DropdownMenuItem
									onClick={() => {
										history('/meu-perfil')
									}}
								>
									<Person24Regular />
									Meu perfil
								</DropdownMenuItem>
								<DropdownMenuItem
									onClick={() => {
										window.open('https://wa.me/555391247553', '_blank')
									}}
								>
									<ChatMultiple24Regular />
									Fale conosco
								</DropdownMenuItem>
								<DropdownMenuItem
									onClick={() => {
										window.open(
											'https://www.decorandoaleiseca.com.br/',
											'_blank'
										)
									}}
								>
									<Globe24Regular /> Ir para o site
								</DropdownMenuItem>
								{/* <DropdownMenuItem
									onClick={() => {
										history('/configuracoes')
									}}
								>
									<Settings24Regular /> Configurações
								</DropdownMenuItem> */}

								<DropdownMenuItem>
									<Alert24Regular /> Notificações
								</DropdownMenuItem>

								<DropdownMenuItem
									onClick={() => {
										history('/logout')
									}}
								>
									<ArrowExit20Regular />
									Sair
								</DropdownMenuItem>
							</DropdownMenuContent>
						</DropdownMenuPortal>
					</DropdownMenuRoot>
				</div>
			</div>
		</header>
	)
}
